import React, { useEffect, useMemo, useRef, useState } from 'react'

// 검색형 드롭다운 — 둥근 입력 + 둥근 패널, 타이핑으로 필터
// options: [{value, label}], onChange(value)
export default function SearchSelect({ options, value, onChange, placeholder = '선택', width = 300 }) {
  const [open, setOpen] = useState(false)
  const [q, setQ] = useState('')
  const ref = useRef(null)

  useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false) }
    document.addEventListener('mousedown', onDoc)
    return () => document.removeEventListener('mousedown', onDoc)
  }, [])

  const selected = options.find((o) => o.value === value)
  const filtered = useMemo(() => {
    const needle = q.trim().toLowerCase()
    if (!needle) return options.slice(0, 200)
    return options.filter((o) => o.label.toLowerCase().includes(needle)).slice(0, 200)
  }, [options, q])

  return (
    <div className="ss-wrap" style={{ width }} ref={ref}>
      <div className="ss-input" onClick={() => setOpen(true)}>
        <input
          placeholder={selected ? selected.label : placeholder}
          value={open ? q : (selected?.label ?? '')}
          onChange={(e) => { setQ(e.target.value); setOpen(true) }}
          onFocus={() => setOpen(true)}
        />
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
          <circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" />
        </svg>
      </div>
      {open && (
        <div className="ss-pop">
          {filtered.length === 0 && <div className="ss-empty muted">검색 결과가 없습니다</div>}
          {filtered.map((o) => (
            <button
              key={o.value}
              type="button"
              className={o.value === value ? 'on' : ''}
              onClick={() => { onChange(o.value); setOpen(false); setQ('') }}
            >{o.label}</button>
          ))}
        </div>
      )}
    </div>
  )
}
